import React from 'react';

const ICONS = {
  operative: <><path d="M12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z" /><path d="M5 21v-2.5C5 15.5 7.7 13 11 13h2c3.3 0 6 2.5 6 5.5V21H5Z" /></>,
  region: <><path d="m3 6 5-3 8 3 5-3v15l-5 3-8-3-5 3V6Z" /><path d="M8 3v15M16 6v15" fill="none" stroke="currentColor" strokeWidth="2" /></>,
  gear: <><path d="m4 5 3-2 3 3-2 3-4-4Zm8 5 7 7-2 2-7-7 2-2Z" /><path d="m14 3 2 2-5 5-2-2 5-5Z" /></>,
  pack: <><path d="M8 7V5c0-2 1.5-3 4-3s4 1 4 3v2h3v14H5V7h3Zm2 0h4V5h-4v2Z" /><path d="M8 11h8v3H8z" fill="var(--pl-color-panel, #181916)" /></>,
  log: <><path d="M5 3h14v18H5V3Z" /><path d="M8 7h8M8 11h8M8 15h6" fill="none" stroke="var(--pl-color-panel, #181916)" strokeWidth="2" /></>,
  menu: <path d="M3 5h18v3H3V5Zm0 6h18v3H3v-3Zm0 6h18v3H3v-3Z" />,
  pin: <path d="m8 3 8 2-2 3 3 5-4 1-2 7-2-6-4-1 4-4-1-7Z" />,
  unpin: <><path d="m8 3 8 2-2 3 3 5-4 1-2 7-2-6-4-1 4-4-1-7Z" /><path d="M4 4 20 20" fill="none" stroke="var(--pl-color-panel, #181916)" strokeWidth="2.5" /></>,
  close: <path d="m5 3 7 7 7-7 2 2-7 7 7 7-2 2-7-7-7 7-2-2 7-7-7-7 2-2Z" />,
  collapse: <path d="M4 10h16v4H4z" />,
  expand: <path d="M4 4h7v3H7v4H4V4Zm9 0h7v7h-3V7h-4V4ZM4 13h3v4h4v3H4v-7Zm13 0h3v7h-7v-3h4v-4Z" />,
  idle: <path d="M5 4h5v16H5V4Zm9 0h5v16h-5V4Z" />,
  move: <path d="m13 3 8 9-8 9v-6H3V9h10V3Z" />,
  rest: <path d="M20 15.5A8.5 8.5 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5Z" />,
  scavenge: <><path d="M4 18h16v3H4z" /><path d="m6 16 7-13 3 2-7 13-3-2Z" /><path d="m12 3 7 2-2 4-7-3 2-3Z" /></>,
  hunt: <><path d="M12 2 9 8l-7 1 5 5-1 7 6-3 6 3-1-7 5-5-7-1-3-6Z" /></>,
  effect: <><path d="M12 2 9.7 9.1 3 12l6.7 2.9L12 22l2.3-7.1L21 12l-6.7-2.9L12 2Z" /><path d="m5 3 1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3Z" /></>,
  health: <path d="M12 21S3 15.7 3 9.2C3 5.6 7.5 3.3 12 7c4.5-3.7 9-1.4 9 2.2C21 15.7 12 21 12 21Z" />,
  damage: <path d="m14 2 1.8 1.8-2.7 4.4 7.1 7.1-4.9 4.9-7.1-7.1-4.4 2.7L2 14l4-5.3 2.7-2.7L14 2Zm1.3 14 1.7 1.7.7-.7-1.7-1.7-.7.7Z" />,
  armor: <path d="M12 2 4 5v6c0 5.2 3.4 9.2 8 11 4.6-1.8 8-5.8 8-11V5l-8-3Zm0 4 4 1.5V11c0 2.7-1.5 5.2-4 6.8V6Z" />,
  speed: <><path d="M13 4a8 8 0 1 1-7.6 5.5h3.3A5 5 0 1 0 13 7V4Z" /><path d="M2 3h9v3H2V3Zm1 5h7v3H3V8Zm1 5h5v3H4v-3Z" /></>,
  food: <><path d="M3 9h18c0 5-3.6 9-9 9S3 14 3 9Z" /><path d="M5 20h14v2H5zM8 6c0-2 1-3 1-4m4 4c0-2 1-3 1-4m4 4c0-2 1-3 1-4" fill="none" stroke="currentColor" strokeWidth="2" /></>,
};

export default function Icon({ name, size = 24, className = '' }) {
  return (
    <svg
      aria-hidden="true"
      className={`pl-icon ${className}`.trim()}
      fill="currentColor"
      height={size}
      viewBox="0 0 24 24"
      width={size}
    >
      {ICONS[name] || ICONS.log}
    </svg>
  );
}
